import { TAGButton, TAGSvgIcon } from '@aspendental/shared-components-web';
import { Box, Divider, Fade, ListItemButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import Toolbar from '@mui/material/Toolbar';
import { TransitionProps } from '@mui/material/transitions';
import Typography from '@mui/material/Typography';
import { useRouter } from 'next/router';
import { Dispatch, FC, forwardRef, SetStateAction, useMemo } from 'react';
import { Logout } from '@mui/icons-material';
import { useFacilityId } from '@src/hooks/patient-services/useFacilityId';
import { useAppStore } from '@src/store';
import { iconMap, matchRouteWithItem, navigationItems } from '../PatientServicesNavigationHelpers';
import { appBar, listBoxWrapper, listItemButton, listItemWrapper, listWrapper, logoutBoxWrapper, toolbarWrapper } from './styles';
type PatientServicesMobileNavigationProps = {
  magicLogout: () => void;
  handleLinkTracking: (linkText: string, linkUrl: string) => void;
  isHamburgerMenuOpen: boolean;
  closeHamburgerMenu: Dispatch<SetStateAction<boolean>>;
};
const Transition = forwardRef(function Transition(props: TransitionProps & {
  children: React.ReactElement<any, any>;
}, ref: React.Ref<unknown>) {
  return <Fade ref={ref} {...props} timeout={400} />;
});
const PatientServicesMobileNavigation: FC<PatientServicesMobileNavigationProps> = ({
  magicLogout,
  handleLinkTracking,
  closeHamburgerMenu,
  isHamburgerMenuOpen
}) => {
  const {
    facilityId
  } = useFacilityId();
  const {
    pathname
  } = useRouter();
  const {
    documentsAndRecordsLocations
  } = useAppStore(store => store.officeRollout);
  const visibleNavigationItems = useMemo(() => {
    return navigationItems.filter(menuItem => {
      const isDocsAndRecordsRoute = menuItem.redirect === '/patient-services/documents-and-records';
      if (!isDocsAndRecordsRoute) return true;
      return documentsAndRecordsLocations.includes(facilityId);
    });
  }, [facilityId, documentsAndRecordsLocations]);
  return <Dialog fullScreen open={isHamburgerMenuOpen} TransitionComponent={Transition} data-sentry-element="Dialog" data-sentry-component="PatientServicesMobileNavigation" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
			<AppBar sx={appBar} data-sentry-element="AppBar" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
				<Toolbar style={toolbarWrapper} data-sentry-element="Toolbar" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
					<TAGButton dataTestId="closeButton" onClick={() => closeHamburgerMenu(false)} data-sentry-element="TAGButton" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
						<TAGSvgIcon icon="CloseFunc" height="2rem" width="2rem" data-sentry-element="TAGSvgIcon" data-sentry-source-file="PatientServicesMobileNavigation.tsx" />
					</TAGButton>
				</Toolbar>
			</AppBar>
			<List data-test-id="mobile-nav-dialog" sx={listWrapper} data-sentry-element="List" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
				<Box sx={listBoxWrapper} data-sentry-element="Box" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
					{visibleNavigationItems.map(menuItem => {
          const {
            icon,
            title,
            redirect
          } = menuItem;
          const isActiveItem = matchRouteWithItem(title, pathname);
          const IconComponent = iconMap[icon];
          return <Box key={title}>
								<ListItemButton onClick={() => handleLinkTracking(title, redirect)} sx={listItemWrapper({
              isActiveItem
            })}>
									<IconComponent sx={{
                width: '1rem',
                height: '1rem'
              }} />
									<Typography sx={{
                lineHeight: '1.25rem'
              }} variant={isActiveItem ? 'bodyMediumBold' : 'bodyMediumBook'}>
										{title}
									</Typography>
								</ListItemButton>
								<Divider />
							</Box>;
        })}
				</Box>
				<Box sx={logoutBoxWrapper} data-sentry-element="Box" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
					<ListItemButton onClick={magicLogout} sx={listItemButton} data-sentry-element="ListItemButton" data-sentry-source-file="PatientServicesMobileNavigation.tsx">
						<Logout sx={{
            height: '1.5rem',
            width: '1.5rem'
          }} data-sentry-element="Logout" data-sentry-source-file="PatientServicesMobileNavigation.tsx" />
						<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="PatientServicesMobileNavigation.tsx">Logout</Typography>
					</ListItemButton>
				</Box>
			</List>
		</Dialog>;
};
export default PatientServicesMobileNavigation;